import cx from 'classnames'
import { ArrowRefresh2 } from 'blaze-ui/icons'
import { AutoReloadButton } from 'components/Settings/TieredBilling/components/AutopilotDetails/AutopilotDetailsV2'
import { Text } from 'blaze-ui/Text/Text'

import Styles from './AutoReload.module.scss'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'

export const AutoReload = ({ className }: { className?: string }) => {
  const workspace = useCurrentWorkspace()

  return (
    <div className={cx(Styles.autoReloadContainer, { [Styles.on]: workspace?.auto_reload_credits }, className)}>
      <ArrowRefresh2 size={15} />
      <div className={Styles.text}>
        <Text variant="secondary">Auto-reload</Text>
      </div>
      <AutoReloadButton onPress={() => {}} className={Styles.autoReloadButton} />
    </div>
  )
}
